import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FlowState } from './flow.reducer';

export const selectFlowState = createFeatureSelector<FlowState>('flow');

export const selectCurrentContext = createSelector(
    selectFlowState,
    (state: FlowState) => state.context
);

export const selectSelectedItems = createSelector(
    selectFlowState,
    (state: FlowState) => state.selectedIds
);
